import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UpdateUser } from "../../../utilities/api/user/user-service";
import { UserDataObjType } from "../../../utilities/types";

const initialState = {
    status: "",
    message: ""
}

export const UpdateUserData = createAsyncThunk("UpdateUser/AllUserList", (payload: UserDataObjType) => UpdateUser("", payload))

const UpdateUserSlice = createSlice({
    name: "UpdateUser",
    initialState,
    reducers: {
        resetUpadateSlice: () => initialState
    },
    extraReducers: (builder) => {
        builder

            .addCase(UpdateUserData.fulfilled, (state, action: PayloadAction<any>) => {
                if (action.payload.status === 200) {
                    state.status = action.payload.status
                    state.message = action.payload.data.message
                } else {
                    state.status = action.payload.response.status
                    state.message = action.payload.response.data.message
                }

            })

    }

})

export default UpdateUserSlice.reducer
export const { resetUpadateSlice } = UpdateUserSlice.actions